<template>
    <ul>
        <li v-for="(num, index) in max" :key="index" @click="$emit('ratings', {type: rating, value: num})">
            <img v-show="num>rating.value" :src="require(`@/assets/image/unRateStarNoB.svg`)" class="rateMoreImg">
            <img v-show="num<=rating.value" :src="require(`@/assets/image/rateStarNoB.svg`)" class="rateMoreImg">
        </li> 
    </ul>
</template>

<script>
export default {
    name: 'Star',
    props: ['max', 'rating'],
}
</script>

<style lang="scss" scoped>
    ul{
        display: flex;
        li{
            flex: 1;
        }
    }
</style>